console.clear();

var pym = require("./lib/pym");
var pymChild;
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints.js");
var { COLORS, fmtComma } = require("./lib/helpers");
var { getQuants } = require("./util.js");
var $ = require("./lib/qsa");
var d3 = {
  // ...require("d3/dist/d3.js"),
  ...require("d3-axis"),
  ...require("d3-scale"),
  ...require("d3-force"),
  ...require("d3-selection"),
  ...require("d3-transition")
};

var initialMode = "uninsured_rate";

var { sqrt, PI } = Math;
var { makeTranslate } = require("./lib/helpers");

var controls = document.querySelector('.controls');
var graphic = document.querySelector('.graphic');

var widthBeforeChange = graphic.offsetWidth;

// Initialize the graphic.
var onWindowLoaded = function() {
  renderChart(initialMode,"big");
  renderChart(initialMode,"small");

  window.addEventListener("resize", () => {

    //check if width changed
    var widthAfterChange = graphic.offsetWidth;
    if(widthAfterChange!=widthBeforeChange){
      renderChart($.one("input:checked", controls).value,"big");
      renderChart($.one("input:checked", controls).value,"small");
      widthBeforeChange = widthAfterChange;
    }

  });

  pym.then(function(child) {
    pymChild = child;
    pymChild.sendHeight();
  });

  
};


var currentData = window.DATA;
var stateAbbr = window.STATE_ABBR;

var smallHeight = 50;
if (isMobile.matches) {
  smallHeight = 75;
}

var ticksX = 5;

// setup categories/colors
// Extract categories from data
var categories = [];
var valueColumn = "abortion_ban_aggregated";

if (LABELS.legend_labels && LABELS.legend_labels !== "") {
  // If custom legend labels are specified
  categories = LABELS.legend_labels.split("|").map(l => l.trim());

} else {
  // Default: Return sorted array of categories
  currentData.forEach(function(state) {
    if (state != null) {
      categories.push(state[valueColumn]);
    }
  });

  //dedupe
  categories = Array.from(new Set(categories)).sort();
}


var colorScale = d3
      .scaleOrdinal()
      .domain(categories)
      .range([
        COLORS.orange2,
        COLORS.orange4,
        "#ccc"
      ]);

// //add key
var legendElement = document.querySelector(".graphic .legend");

colorScale.domain().forEach(function(key, i) {
  var keyItem = d3.select(legendElement).append("li").classed("key-item", true);

  keyItem.append("b").style("background", colorScale(key));

  keyItem.append("label").html(key);

});



// Bubbles
function renderChart(mode,size) {

  var metric = mode;

  var Y_FORCE = .03;
  var X_FORCE = 1;
  var COLLIDE_FORCE = 1;
  var MIN_RADIUS = 12;
  var MAX_RADIUS = isMobile.matches ? 75 : 100;
  var HIDE_TEXT = 6;
  var MIN_TEXT = 10;

  if (size == "small") {
    X_FORCE = 0.5;
    MIN_RADIUS = 0.5;
    MAX_RADIUS = isMobile.matches ? 7 : 7;
  }

  var svg = document.querySelector(".graphic svg.big");
  var chart = document.querySelector("#bubble-graphic");
  var margin = {
    top: 5,
    bottom: 5,
    left: 55,
    right:30
  }

  if (size == "small") {
    var svg = document.querySelector(".graphic svg.small");
    var chart = document.querySelector("#bubble-graphic-key");
    margin.top = 5;
    margin.bottom = 5;
    margin.left = 20;
    margin.right = 20;
  }


  svg.innerHTML = "";

  var chartElement = d3.select(svg)
    .append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);

  var chartWidth = chart.offsetWidth;
  var chartHeight = chartWidth / 3;
  svg.setAttribute("width", chartWidth);
  svg.setAttribute("height", chartHeight);

  if (mode == "maternity_deserts") {
    svg.classList.add("maternity_deserts");
  } else {
    svg.classList.remove("maternity_deserts");
  }

  var xForce = d3.forceX().x(xAccess).strength(X_FORCE);
  var yForce = d3.forceY().strength(Y_FORCE);
  var collider = d3.forceCollide().strength(COLLIDE_FORCE);
  collider.radius(collisionRadius);

  // var items = ["uninsured_rate","maternity_deserts", "child_poverty", "tanf"];
  var items = ["uninsured_rate","maternity_deserts", "child_poverty"];


  var nodes = currentData.map(function(r) {
    var temp = {};
    items.forEach((item,i) => {
      
      var perc= r[item];
      var {population, state, abortion_ban_aggregated} = r;
      var y = 1 - (population / maxPop) * 10000;
      var vy = 0;

      temp[item] = {
        y,
        vy,
        perc,
        population,
        state,
        abortion_ban_aggregated
      };
    })

    return {
      "uninsured_rate": temp["uninsured_rate"],
      "maternity_deserts": temp["maternity_deserts"],
      "child_poverty": temp["child_poverty"]
      // "tanf": temp["tanf"]
    }
  });



  var xScale = {};
  var minmax = {};

  items.forEach(item => {

    var percentages = nodes.map(d => d[item].perc).filter(n => typeof(n) == "number");
    var minPerc = Math.min(...percentages) - 1;
    if(minPerc<0) minPerc = 0;
    var maxPerc = Math.max(...percentages) +1;

    if (size == "small") {
      minmax[item] = [minPerc,maxPerc];
      minPerc = 0;
      maxPerc = 100;
    }

    xScale[item] = d3
      .scaleLinear()
      .domain([minPerc, maxPerc])
      .range([0, chartWidth-margin.right-margin.left]);
  })

  function xAccess(d) {
    return xScale[d.item](d.perc);
  }

  var pops = nodes.map(d => d["uninsured_rate"].population);
  var minPop = Math.min(...pops);
  var maxPop = Math.max(...pops);

  function nodeRadius(d) {
    var a = d.population / maxPop * (MAX_RADIUS**2);
    var r = Math.sqrt(a / PI);
    return Math.max(r, MIN_RADIUS);
  }

  function collisionRadius(d) {
    return nodeRadius(d) + 1;
  }

  var simulationMaster = {};

  items.forEach(item => {
    var tempNodes = nodes.map(d =>  {
      d[item]["item"] = item;
      return d[item]
    });

    let simulation = d3.forceSimulation();
        simulation.alpha(5);
        simulation.alphaDecay(0.04);
        // simulation.stop(); // only run when visible

    simulation.force("x", xForce);
    simulation.force("y", yForce);
    simulation.force("collide", collider);

    simulation.nodes(tempNodes);
    simulation.tick(1000);

    simulationMaster[item] = simulation;
  })

  //get biggest y values including radius
  var yValues = [
    ...nodes.map(d => Math.abs(d["uninsured_rate"].y) + nodeRadius(d["uninsured_rate"]) ),
    ...nodes.map(d => Math.abs(d["maternity_deserts"].y) + nodeRadius(d["maternity_deserts"]) ),
    ...nodes.map(d => Math.abs(d["child_poverty"].y) + nodeRadius(d["child_poverty"]) )
    // ...nodes.map(d => Math.abs(d["tanf"].y) + nodeRadius(d["tanf"]) )
  ];

  var maxDist = Math.max(...yValues);

  chartHeight = (maxDist * 2) + margin.bottom + margin.top;
  if (size == "small") {
    smallHeight = chartHeight - margin.top;
  }
  svg.setAttribute("height", chartHeight+5);
  svg.setAttribute("overflow", "visible");

    // Create D3 axes.
    var xAxis = d3
      .axisTop()
      .scale(xScale[metric])
      .ticks(ticksX)
      .tickFormat(function(d) {
        return d.toFixed(0) + "%";
      });

    // Render axes to chart.
    chartElement
      .append("g")
      .attr("class", "x axis")
      .call(xAxis);

    if (size != "small") {
    // Render grid to chart.
    chartElement
      .append("g")
      .attr("class", "x grid")
      .attr("transform", makeTranslate(0, chartHeight))
      .call(xAxis.tickSize(chartHeight, 0, 0).tickFormat(""));
    }

    if (size == "small") {

      var rectDetails = [
        {
          "uninsured_rate":{
            min:0,
            max:xScale[metric](100)
          },
          "maternity_deserts":{
            min:0,
            max:xScale[metric](100)
          },
          "child_poverty":{
            min:0,
            max:xScale[metric](100)
          }
          // "tanf":{
          //   min: 0,
          //   max:xScale[metric](100)
          // }
        },
        {
          "uninsured_rate":{
            min:xScale[metric](minmax.uninsured_rate[0])-5,
            max:xScale[metric](minmax.uninsured_rate[1])+5
          },
          "maternity_deserts":{
            min:xScale[metric](minmax["maternity_deserts"][0])-5,
            max:xScale[metric](minmax["maternity_deserts"][1])+5
          },
          "child_poverty":{
            min:xScale[metric](minmax["child_poverty"][0])-5,
            max:xScale[metric](minmax["child_poverty"][1])+5
          }
          // "tanf":{
          //   min:xScale[metric](minmax["tanf"][0])-5,
          //   max:xScale[metric](minmax["tanf"][1])+5
          // }
        },
      ]

      chartElement
        .append("g")
        .selectAll("rect")
        .data(rectDetails)
        .enter()
        .append("rect")
        .attr("class",(d,i)=>`bracket-rect i${i}`)
        .attr("x",d => d[metric].min)
        .attr("y",0)
        .attr("width",d => d[metric].max - d[metric].min)
        .attr("height",chartHeight-margin.top)
        .attr("rx",0)
    }


  // Add state circles
  chartElement
    .append("g")
    .selectAll("circle")
    .data(nodes)
    .enter()
    .append('circle')
    .attr("cx", d => d[metric].x)
    .attr("cy", d => d[metric].y + ((chartHeight-margin.top) / 2))
    .attr("r", d => nodeRadius(d[metric]))
    .attr("fill", d => colorScale(d[metric][valueColumn]))
    .attr("class", "state-circle")
    .attr("data-perc", d => d[metric].perc)
    .attr("data-state", d => d[metric].state)
    .attr("data-mode", mode)
    .attr("data-bucket", d => d[metric].bucket);

  // Add state labels

  if (size != "small") {
    chartElement
      .append("g")
      .selectAll("text")
      .data(nodes)
      .enter()
      .append('text')
      .attr("x", d => d[metric].x)
      .attr("y", d => d[metric].y + ((chartHeight-margin.top) / 2) + (nodeRadius(d[metric])/2 * .35) + 1)
      .attr("font-size", d => Math.max(nodeRadius(d[metric])/9*5, MIN_TEXT) + "px")
      .attr("display", d => nodeRadius(d[metric])/2 < HIDE_TEXT ? "none" : "block")
      .attr("class", "state-text")
      .attr("fill", "#fff")
      // .attr('fill', d => (d[metric][valueColumn] == "No current ban") ? "#888" : "#fff")
      .text(function(d){
        var state = d[metric].state;
        var abbr = stateAbbr[state].abbrev;
        return abbr;
      })

  }

  // Tooltips
  var tooltip = document.querySelector(".bubble-tooltip");

  function onMove(e) {
    if(isMobile.matches) return;

    var bounds = chart.getBoundingClientRect();
    var offsetX = e.clientX - bounds.left;
    var offsetY = e.clientY - 105;

    var state = e.target.getAttribute("data-state");
    var data = currentData.filter(d => d.state == state)[0];

    if (!state || !data) {
      return tooltip.classList.remove("show");
    }

    var uninsured_rate = data.uninsured_rate;
    var maternity_deserts = data["maternity_deserts"].toFixed(1);
    var child_poverty = data["child_poverty"].toFixed(1);
    // var tanf = data["tanf"];

    var mode = e.target.getAttribute('data-mode');

      tooltip.innerHTML = `
        <div class="tooltip-label"><h3>${stateAbbr[state].key}</h3></div>
        <div class="tooltip-label number uninsured_rate">Uninsured rate (women age 19-64): <strong>${uninsured_rate}%</strong></div>
        <div class="tooltip-label number child_poverty">Child poverty rate: <strong>${child_poverty}%</strong></div>
        <div class="tooltip-label number maternity_deserts">Population living in maternity care deserts: <strong>${maternity_deserts}%</strong></div>
        <div class="tooltip-label number">Population: <strong>${fmtComma(data.population)}</strong></div>`;

    tooltip.classList.add("show");

    d3.select(`.tooltip-label.${mode}`).classed("selected", true);

    var left = offsetX < bounds.width / 2 ? offsetX + 10 : offsetX - 4 - tooltip.offsetWidth;
    tooltip.style.left = left + "px";
    tooltip.style.top = offsetY + 10 + "px";
  }

  if (!isMobile.matches && size !== "small") {
    chart.addEventListener("mousemove", onMove)
  }

  if (size == "big") {
    var controls = document.querySelector('.controls');
    controls.addEventListener('change', (e) => changeMode(e,xScale,chartHeight,xAxis,nodeRadius));
  }

}

var modeHed = d3.select("span.mode");

function changeMode(e,xScale,chartHeight,xAxis,nodeRadius) {


  var durationLength = 2000;
  var delayLength = 500;

  const HIDE_TEXT = 6;
  const MIN_TEXT = 10;

  // get right name
  var mode = e.target.value;
  var metric = mode;

  //change hed
  var hedText = LABELS[`hed_${mode}`];
  modeHed.text(hedText);

  // get xscale?
  var thisScale = xScale[metric];

  // transition axis
  var ticksX = isMobile.matches ? 5 : 5;

  xAxis =
    d3.axisTop()
    .ticks(ticksX)
    .scale(thisScale)
    .tickFormat(function(d) {
      return d.toFixed(0) + "%";
    });

  var svg1 = d3.select("svg.big")
  var svg2 = d3.select("svg.small")

  svg1.select(".x.axis")
   .transition().duration(durationLength)
   .call(xAxis);

  svg1.select(".x.grid")
    .transition().duration(durationLength)
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis.tickSize(chartHeight, 0, 0).tickFormat(""));

  // transition bubbles

  svg1.selectAll(".state-circle")
    .attr("data-mode", mode)
    .attr("data-bucket", d => {
      return d[metric].bucket
    });

  svg1.selectAll(".state-circle")
    .transition().duration(durationLength/2).delay(delayLength)
    .attr("cx", d => d[metric].x)
    .attr("cy", d => d[metric].y + (chartHeight / 2))
    .attr("data-perc", d => d[metric].perc);

  // transition state names
  svg1.selectAll(".state-text")
    .transition().duration(durationLength/2).delay(delayLength)
    .attr("x", d => d[metric].x)
    .attr("y", d => d[metric].y + (chartHeight / 2) + (nodeRadius(d[metric])/2 * .35) + 1)

  // move small bubbles

  svg2.selectAll(".bracket-rect")
    .transition().duration(durationLength/2).delay(delayLength)
    .attr("x",d => d[metric].min)
    .attr("width",d => d[metric].max - d[metric].min)

  svg2.selectAll(".state-circle")
    .attr("data-mode", mode)
    .attr("data-bucket", d => {
      return d[metric].bucket
    });
  svg2.selectAll(".state-circle")
    .transition().duration(durationLength/2).delay(delayLength)
    .attr("cx", d => d[metric].x)
    .attr("cy", d => d[metric].y + smallHeight/2)
    // .attr("cy", d => d[metric].y + (chartHeight / 2))
    .attr("data-perc", d => d[metric].perc);

  pymChild.sendHeight();
};


window.onload = onWindowLoaded;


